/* eslint-disable @typescript-eslint/no-explicit-any */
import { AbstractControl, AsyncValidatorFn, ValidationErrors, ValidatorFn } from '@angular/forms';
import { Observable, map, of } from 'rxjs';

export class NameValidators {
  static asyncUniqueNameValidator(service: any, initialName: string, ...params: any[]): AsyncValidatorFn {
    return (control: AbstractControl): Observable<ValidationErrors | null> => {
      const name = control?.getRawValue().trim();

      if (name) {
        if (name.toLowerCase() === initialName?.toLowerCase()) {
          return of(null);
        }

        const serviceParams = [name as string, ...params];
        return service?.isNameUnique(...serviceParams).pipe(map((unique: boolean) => (unique ? null : { nameExists: true })));
      }
      return of(null);
    };
  }

  static asyncUniqueNameValidatorDynamic(service: any, initialName: string, paramsFactory: () => any[]): AsyncValidatorFn {
    return (control: AbstractControl): Observable<ValidationErrors | null> => {
      const name = control?.getRawValue()?.trim();

      if (name) {
        if (name.toLowerCase() === initialName?.toLowerCase()) {
          return of(null);
        }

        const params = paramsFactory();
        if (params.some((param) => param == null)) {
          return of(null);
        }

        return service?.isNameUnique(name as string, ...params).pipe(map((unique: boolean) => (unique ? null : { nameExists: true })));
      }
      return of(null);
    };
  }

  static asyncUniqueValueValidatorByContext(
    service: any,
    initialValue: string,
    contextControlName: string,
    functionName: string,
    errorName: string,
    ...params: any[]
  ): AsyncValidatorFn {
    return (control: AbstractControl): Observable<ValidationErrors | null> => {
      const value = control?.getRawValue()?.trim();
      const context = control?.parent?.get(contextControlName)?.getRawValue();

      if (value && context) {
        if (value.toLowerCase() === initialValue?.toLowerCase()) {
          return of(null);
        }

        const serviceParams = [value as string, context, ...params];
        return service?.[functionName](...serviceParams).pipe(map((unique: boolean) => (unique ? null : { [errorName]: true })));
      }
      return of(null);
    };
  }

  static syncUniqueValueValidator(values: string[], initialValue: string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const raw = control?.getRawValue();
      const value = typeof raw === 'string' ? raw.trim() : '';

      if (value) {
        if (value.toLowerCase() === initialValue?.toLowerCase()) {
          return null;
        }
        return values.some((elem) => elem?.trim().toLowerCase() === value.toLowerCase()) ? { nameExists: true } : null;
      }
      return null;
    };
  }
}
